export function getLandsbankinnUrlByLocale(locale: string) {
  switch (locale) {
    case 'pl':
      return 'https://www.landsbankinn.pl';
    case 'en':
      return 'https://www.landsbankinn.com';
    default:
      return 'https://www.landsbankinn.is';
  }
}
